import * as React from "react";
import {ChangeEvent} from "react";
import {InputFieldState} from "./InputFieldState";

interface TextInputProps {
  label: string;
  state: InputFieldState
  onChange?: (value: string, event: ChangeEvent<HTMLTextAreaElement>) => void;
  errorMessage?: string,
  editable?: boolean,
}

/**
 * Text Input Element
 */
export class TextareaInput extends React.Component<TextInputProps> {

  public static defaultProps = {
    label: "Label",
  };

  render() {
    return <label><div className="labelText">{this.props.label}</div><textarea className="react-textarea" onChange={(event) => {
      this.props.onChange(event.target.value, event);
    }} value={this.props.state.value}/>
      <div className="error_message">{this.props.state.errorMessage}</div>
    </label>
  }
}